import { hexToRgba } from '../../utils/colorUtils'
import SpinnerIcon from '../assets/SpinnerIcon.svg'

const SHIMMER_PEAK_OPACITY = 0.15
const DEFAULT_LABEL = 'Fetching balance...'
const buildShimmerHighlight = (accentColor: string) =>
  `linear-gradient(90deg, ${hexToRgba(accentColor, 0)} 21.159%, ${hexToRgba(
    accentColor,
    SHIMMER_PEAK_OPACITY
  )} 50.115%, ${hexToRgba(accentColor, 0)} 79.071%)`

export interface GiftCardGIFTRRedeemInputProps {
  accentColor: string
  label?: string
}

const GiftCardGIFTRRedeemInput = ({ accentColor, label = DEFAULT_LABEL }: GiftCardGIFTRRedeemInputProps) => {
  return (
    <div
      role='status'
      aria-live='polite'
      className='ui-relative ui-flex ui-h-[48px] ui-w-full ui-items-center ui-overflow-hidden ui-rounded-[10px] ui-bg-[#f4f4f5] ui-px-[10px]'
    >
      <div
        aria-hidden
        className='ui-pointer-events-none ui-absolute ui-inset-0 ui-animate-slide motion-reduce:ui-animate-none !ui-duration-1000'
        style={{ background: buildShimmerHighlight(accentColor) }}
      />

      <div className='ui-relative ui-flex ui-flex-1 ui-items-center ui-gap-1 ui-px-1'>
        <span className='ui-flex ui-size-4 ui-shrink-0 ui-items-center ui-justify-center'>
          <img src={SpinnerIcon} alt='' className='ui-size-[13px] ui-animate-spin' />
        </span>
        <p className='ui-text-text-sm-medium ui-text-black ui-opacity-40'>{label}</p>
      </div>
    </div>
  )
}

export default GiftCardGIFTRRedeemInput
